// Email validation function
export const isEmail = (email) => {
  const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
};

// Modal handling functions
export const handleModal = (modalId, action) => {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.style.display = action === 'open' ? 'block' : 'none';
  }
};

// Tab switching functions
export const switchToTeamTab = () => {
  const personalElements = document.querySelectorAll('.personal');
  const teamElements = document.querySelectorAll('.for-teams');
  const teamTab = document.querySelector('.teamtab');
  const selfTab = document.querySelector('.selftab');

  personalElements.forEach(el => el.style.display = 'none');
  teamElements.forEach(el => el.style.display = 'flex');
  teamTab?.classList.add('tabclassactive');
  selfTab?.classList.remove('tabclassactive');
};

export const switchToSelfTab = () => {
  const personalElements = document.querySelectorAll('.personal');
  const teamElements = document.querySelectorAll('.for-teams');
  const teamTab = document.querySelector('.teamtab');
  const selfTab = document.querySelector('.selftab');

  personalElements.forEach(el => el.style.display = 'flex');
  teamElements.forEach(el => el.style.display = 'none');
  selfTab?.classList.add('tabclassactive');
  teamTab?.classList.remove('tabclassactive');
};

// Form validation functions
export const validateEmail = (email, errorElementId) => {
  const errorElement = document.getElementById(errorElementId);
  if (!email) {
    errorElement.innerHTML = 'Please Enter Email';
    return false;
  }
  if (!isEmail(email)) {
    errorElement.innerHTML = 'Email not Valid';
    return false;
  }
  errorElement.innerHTML = '';
  return true;
};

export const validatePassword = (password, errorElementId) => {
  const errorElement = document.getElementById(errorElementId);
  if (!password) {
    errorElement.innerHTML = 'Please Enter Password';
    return false;
  }
  const match = password.match(/^(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/);
  if (!match) {
    errorElement.innerHTML = 'Please enter atleast 1 Number, 1 Special Character and Minimum 8 Characters.';
    return false;
  }
  errorElement.innerHTML = '';
  return true;
};

export const validateConfirmPassword = (password, confirmPassword, errorElementId) => {
  const errorElement = document.getElementById(errorElementId);
  if (!confirmPassword) {
    errorElement.innerHTML = 'Please Enter Confirm Password';
    return false;
  }
  if (confirmPassword !== password) {
    errorElement.innerHTML = 'Confirm Password Should be Same as Password';
    return false;
  }
  errorElement.innerHTML = '';
  return true;
};





// Stripe checkout function
export const gotoCheckout = (sessionId) => {
  const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production';
  const stripeKey = isProduction 
    ? process.env.REACT_APP_STRIPE_LIVE_PUBLISHABLE_KEY 
    : process.env.REACT_APP_STRIPE_TEST_PUBLISHABLE_KEY;
  
  if (!stripeKey) {
    alert('Stripe key not configured. Please contact support.');
    return;
  }
  
  const stripe = window.Stripe(stripeKey);
  stripe.redirectToCheckout({
    sessionId: sessionId
  }).then(function(result) {
    if (result.error) {
      alert(result.error.message);
    }
  }).catch(function(error) {
    alert('Payment redirect failed. Please try again.');
    console.error('Stripe error:', error);
  });
};

// Handle plan success redirect
export const handlePlanSuccess = (companyId, planId, noOfWorkers) => {
  const successUrl = `/plan-success?company_id=${encodeURIComponent(companyId)}&plan_id=${encodeURIComponent(planId)}&no_of_workers=${encodeURIComponent(noOfWorkers)}`;
  window.location.href = successUrl;
};

// Handle plan failure redirect
export const handlePlanFailure = (companyId, planId, noOfWorkers, errorCode = null, errorMessage = null) => {
  let failureUrl = `/plan-failure?company_id=${encodeURIComponent(companyId)}&plan_id=${encodeURIComponent(planId)}&no_of_workers=${encodeURIComponent(noOfWorkers)}`;
  
  if (errorCode) {
    failureUrl += `&error_code=${encodeURIComponent(errorCode)}`;
  }
  
  if (errorMessage) {
    failureUrl += `&error_message=${encodeURIComponent(errorMessage)}`;
  }
  
  window.location.href = failureUrl;
};

// User count validation
export const validateUserCount = (count, errorElementId) => {
  const errorElement = document.getElementById(errorElementId);
  if (!count) {
    errorElement.innerHTML = 'Please enter number of users';
    return false;
  }
  if (count > 100) {
    errorElement.innerHTML = "Can't add more then 100 users";
    return false;
  }
  errorElement.innerHTML = '';
  return true;
}; 